import FileSaver from 'file-saver'
import React, { useEffect } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { QAQCRequests } from 'submodules/nerit-aquatec-sdk/services/qaqc/QAQCRequests'

interface ICPProps {
	executionCode: number
	fileLabel?: string
}

function buildExportBaseName(executionCode: number, fileLabel?: string): string {
	const raw = fileLabel?.trim()
	if (raw) {
		const safe = raw.replace(/[^a-zA-Z0-9À-ÿ _-]/g, '_').replace(/\s+/g, '_').slice(0, 80)
		if (safe) return `qaqc_${safe}`
	}
	return `qaqc_execucao_${executionCode}`
}

/**
 * Exporta o resultado da execução QA/QC para Excel.
 */
export function ButtonExportQAQCResultCP(props: ICPProps): JSX.Element {
	const exportRequest = useRequest<Blob>('none')
	useEffect(onExportRequestChange, [exportRequest.isAwaiting])

	function exportExecution(): void {
		exportRequest.runRequest(QAQCRequests.exportResult(props.executionCode))
	}

	function onExportRequestChange(): void {
		if (!RequestUtils.isValidRequestReturn(exportRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE)) return
		const base = buildExportBaseName(props.executionCode, props.fileLabel)
		FileSaver.saveAs(exportRequest.responseData!, `${base}_${Date.now()}.xlsx`)
	}

	return (
		<ButtonCP
			tooltip={'Exportar resultado em Excel'}
			icon={'file-excel'}
			onClick={exportExecution}
			size={'small'}
			type={'ghost'}
			loading={exportRequest.isAwaiting}
		/>
	)
}
